module.exports = __webpack_public_path__ + "static/media/avatar.7001c37e.png";